import React from 'react'
import { Grid } from '@material-ui/core'
import { Input } from 'src/components'
import { useFormContext } from 'react-hook-form'
import { formatPerimeterAnimal } from 'src/utils/recordValidation'
import { formatWeightAnimal } from 'src/utils'
import { useStyles } from './styles'
import { WeighingFormData } from './hooks/useWeighing'

export const TapeWeighingFields: React.FC = () => {
  const {
    watch,
    setValue,
    clearErrors,
    formState: { errors }
  } = useFormContext<WeighingFormData>()

  const styles = useStyles()

  return (
    <>
      <div className={styles.weightingImageContainer}>
        <img src={'/img/animal_ weight.png'} alt='Pesagem' />
      </div>

      <div className={styles.inputWithEditToggle}>
        <Grid container spacing={3} style={{ marginTop: 8 }}>
          <Grid item xs={12} sm={6}>
            <Input
              label='Perímetro torácico, atrás da espádua em (cm)'
              value={watch('fitaPerimetro') || ''}
              error={errors?.fitaPerimetro?.message}
              onChange={(value: string) => {
                const clean = value.replace(/[^0-9.,]/g, '')
                setValue('fitaPerimetro', clean)
                clearErrors('fitaPerimetro')
              }}
              onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                const v = (e.target.value || '').replace(/[^0-9.,]/g, '')
                setValue('fitaPerimetro', formatPerimeterAnimal(v))
              }}
              onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
                const v = (e.target.value || '').replace(/[^0-9.,]/g, '')
                setValue('fitaPerimetro', v)
              }}
              helperText={() => (
                <div className={styles.helperTextContainer}>
                  <p>Na pesagem com fita, é utilizdo a fórmula de Quetlet: P = C² x L x 87,5</p>
                  <p>onde:</p>
                  <p>P = Peso vivo (kg)</p>
                  <p>C = Perímetro torácico, atrás da espádua (m))</p>
                  <p>L = Comprimento do corpo da ponta da espádua à ponta da nádega (m)</p>
                  <p>87,5 = Coeficiente</p>
                </div>
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Input
              label='Comprimento da ponta da espádua à ponta da nádega em (cm) A -> B'
              value={watch('fitaComprimento') || ''}
              error={errors?.fitaComprimento?.message}
              onChange={(value: string) => {
                const clean = value.replace(/[^0-9.,]/g, '')
                setValue('fitaComprimento', clean)
                clearErrors('fitaComprimento')
              }}
              onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
                const v = (e.target.value || '').replace(/[^0-9.,]/g, '')
                setValue('fitaComprimento', v)
              }}
              onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                const v = (e.target.value || '').replace(/[^0-9.,]/g, '')
                setValue('fitaComprimento', formatPerimeterAnimal(v))
              }}
              helperText={() => (
                <div className={styles.helperTextContainer}>
                  <p>Na pesagem com fita, é utilizdo a fórmula de Quetlet: P = C² x L x 87,5</p>
                  <p>onde:</p>
                  <p>P = Peso vivo (kg)</p>
                  <p>C = Perímetro torácico, atrás da espádua (m))</p>
                  <p>L = Comprimento do corpo da ponta da espádua à ponta da nádega (m)</p>
                  <p>87,5 = Coeficiente</p>
                </div>
              )}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Input label='Peso Aproximado(kg)' value={formatWeightAnimal(watch('peso') || '')} disabled />
          </Grid>
        </Grid>
      </div>
    </>
  )
}
